import script from "./DataFoldingAndBinning.vue?vue&type=script&setup=true&lang=ts"
export * from "./DataFoldingAndBinning.vue?vue&type=script&setup=true&lang=ts"

import "./DataFoldingAndBinning.vue?vue&type=style&index=0&id=3a017499&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3a017499"]])

export default __exports__